import React from 'react';
import { Avatar as DefaultAvatar } from '../Avatar';
import { useChannelStateContext } from '../../context/ChannelStateContext';
import { useChatContext } from '../../context/ChatContext';
import { useTypingContext } from '../../context/TypingContext';
/**
 * TypingIndicator lists users currently typing, it needs to be a child of Channel component
 */
var UnMemoizedTypingIndicator = function (props) {
    var _a;
    var _b = props.Avatar, Avatar = _b === void 0 ? DefaultAvatar : _b, _c = props.avatarSize, avatarSize = _c === void 0 ? 32 : _c, threadList = props.threadList;
    var _d = useChannelStateContext(), channel = _d.channel, thread = _d.thread;
    var client = useChatContext().client;
    var _e = useTypingContext().typing, typing = _e === void 0 ? {} : _e;
    if (((_a = channel === null || channel === void 0 ? void 0 : channel.getConfig()) === null || _a === void 0 ? void 0 : _a.typing_events) === false) {
        return null;
    }
    var typingInChannel = !threadList
        ? Object.values(typing).filter(function (_a) {
            var _b;
            var parent_id = _a.parent_id, user = _a.user;
            return (user === null || user === void 0 ? void 0 : user.id) !== ((_b = client.user) === null || _b === void 0 ? void 0 : _b.id) && !parent_id;
        })
        : [];
    var typingInThread = threadList
        ? Object.values(typing).filter(function (_a) {
            var _b;
            var parent_id = _a.parent_id, user = _a.user;
            return (user === null || user === void 0 ? void 0 : user.id) !== ((_b = client.user) === null || _b === void 0 ? void 0 : _b.id) && parent_id === (thread === null || thread === void 0 ? void 0 : thread.id);
        })
        : [];
    return (React.createElement("div", { className: "str-chat__typing-indicator " + ((threadList && typingInThread.length) || (!threadList && typingInChannel.length)
            ? 'str-chat__typing-indicator--typing'
            : '') },
        React.createElement("div", { className: 'str-chat__typing-indicator__avatars' }, (threadList ? typingInThread : typingInChannel).map(function (_a, i) {
            var user = _a.user;
            return (React.createElement(Avatar, { image: user === null || user === void 0 ? void 0 : user.image, key: (user === null || user === void 0 ? void 0 : user.id) + "-" + i, name: (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.id), size: avatarSize }));
        })),
        React.createElement("div", { className: 'str-chat__typing-indicator__dots' },
            React.createElement("span", { className: 'str-chat__typing-indicator__dot' }),
            React.createElement("span", { className: 'str-chat__typing-indicator__dot' }),
            React.createElement("span", { className: 'str-chat__typing-indicator__dot' }))));
};
export var TypingIndicator = React.memo(UnMemoizedTypingIndicator);
